export enum RequestDataIds {
  RenderContainer = 'render-container',
  Language = 'language',
  BaseUrl = 'base-url',
  Brand = 'brand',
  Channel = 'channel',
  ProxyPrefix = 'proxy-prefix',
  UserToken = 'user-token',
  UserData = 'user-data',
  ClientId = 'client-id',
  Platform = 'platform',
  DepositUrl = 'service-endpoint:deposit',
  WithdrawalUrl = 'service-endpoint:withdrawal',
  LayoutDimensions = 'layout-dimensions',
  AssetsManifest = 'assets-manifest',
  AmsSegments = 'ams:segments',
  Theme = 'theme',
  CrossDomainClickStreamId = 'cross-domain-click-stream-id',
  Operator = 'operator',
  BrandHash = 'brand-hash',
  ApplicationId = 'application-id',
  APIKey = 'api-key',
}
